import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class IndusoftUIInteractionService {
    private static readonly INDUSOFT_UI_SELECTOR = 'indusoft-ui';
    private static readonly VISIBLE_PROPERTY = 'visible';
    private static readonly SHOW_SWITCH_PROPERTY = 'showSwitch';
    private _isVisibleSubject = new BehaviorSubject<boolean>(false);

    public static readonly CHECK_SHOW_SWITCH_EVENT_NAME = 'checkShowSwitch';

    public isVisible$: Observable<boolean> = this._isVisibleSubject.asObservable();

    public get isVisible(): boolean {
        if (!this.indusoftUI)
            return false;

        return this.indusoftUI[IndusoftUIInteractionService.VISIBLE_PROPERTY] ?? false;
    }

    public set isVisible(isVisible: boolean) {
        if (!this.indusoftUI)
            return;

        const oldValue = this._isVisibleSubject.value;
        this.indusoftUI[IndusoftUIInteractionService.VISIBLE_PROPERTY] = isVisible;

        if (oldValue !== isVisible) {
            this._isVisibleSubject.next(isVisible);
        }
    }

    public get isShowSwitch(): boolean {
        if (!this.indusoftUI)
            return false;

        return this.indusoftUI[IndusoftUIInteractionService.SHOW_SWITCH_PROPERTY] ?? false;
    }

    private get indusoftUI(): Element {
        return document.querySelector(IndusoftUIInteractionService.INDUSOFT_UI_SELECTOR) as Element;
    }

    public initialize(): void {
        if (!this.indusoftUI)
            return;

        const domValue = this.indusoftUI[IndusoftUIInteractionService.VISIBLE_PROPERTY] ?? false;
        this._isVisibleSubject.next(domValue);
    }
}